import * as React from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Ustawia widok na gorze strony przy kazdej zmianie trasy.
 *
 * Dwie rzeczy trzeba zrobic naraz, bo kazda sama nie wystarcza:
 *
 * 1. `history.scrollRestoration = 'manual'` — domyslne 'auto' sprawia, ze
 *    przegladarka sama przywraca poprzednia pozycje wpisu w historii, i to PO
 *    tym, jak React wyrenderuje ekran. Bez tego `scrollTo` ponizej zostaje
 *    nadpisane przy cofaniu.
 * 2. `scrollTo(0, 0)` przy zmianie sciezki — react-router nie rusza scrolla przy
 *    nawigacji, wiec nowy ekran dziedziczy offset po poprzednim.
 *
 * Zaleznosc to samo `pathname`, bez `search`: zmiana filtra czy strony listy
 * siedzi w query stringu i nie powinna szarpac widoku na gore.
 *
 * `useLayoutEffect`, nie `useEffect` — scroll ustawia sie przed malowaniem, wiec
 * nie widac mignięcia srodka strony.
 */
export const ScrollToTop = () => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  React.useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
